import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/app/[locale]/error.tsx");
